import React from 'react'
import { rem } from 'polished'
import { components } from 'react-select'
import styled from 'styled-components'

type Props = React.ComponentProps<typeof components.Menu>

const Container = styled.div`
  flex-grow: 1;
  margin-top: ${rem(16)};

  .select-dropdown__menu {
    position: relative;
    flex-grow: 1;
    margin: 0;
    box-shadow: none;

    .select-dropdown__option {
      padding: 0;
      background-color: ${props => props.theme.palette.neutral.eight};
    }
  }
`

const LocationSearchFieldMenu = (props: Props) => {
  const { children } = props

  return (
    <Container>
      <components.Menu {...props}>
        {children}
      </components.Menu>
    </Container>
  )
}

export default LocationSearchFieldMenu
